import { render, staticRenderFns } from "./ForgotPasswordModal.vue?vue&type=template&id=2fe90c4d&scoped=true"
import script from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordModal.vue?vue&type=style&index=0&id=2fe90c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe90c4d",
  null
  
)

export default component.exports